<template>
    <!-- 选择支付方式 -->
    <div>
        <div v-if="h_visible" @click.self="clickCloseDialog" @touchmove.stop.prevent class="containerr flex_layout flex_xy_center">
            <transition name="fade">
                <div v-if="h_transition">
                    <div class="payment-container">
                        <div class="payment-title flex_layout flex_xy_center">选择支付方式</div> 
                        <div class="payment-detail">
                            <p class="detail-title">{{good_title}}（充值账号：{{nickname}}）</p> 
                            <p class="detail-price">
                                <span class="money-icon">￥</span>{{good_price | formatFenToYuan}}
                            </p>
                        </div> 
                        <ul class="detail-list-container">
                            <li @click="clickPay(item.pay_type)" v-for="(item,index) in paytypes" :key="'type'+index" class="detail-list flex_layout flex_y_center flex_x_spacebetween">
                                <div class="flex_layout flex_xy_center">
                                    <img :src="item.icon_url" class="payment-icon"> 
                                    <div class="flex_layout flex_flexDirection_column">
                                        <div>
                                            <span class="payment-name">{{item.title}}</span>
                                            <img v-show="item.activity_icon_url" class="payment-icon-activity" :src="item.activity_icon_url">
                                        </div>
                                        <div v-if="((item.pay_type==10 || item.pay_type==11) && item.activity_icon_url)">
                                            <span class="payment-descriptionweixin">亿万用户的选择，更快更安全</span>
                                        </div>
                                    </div>
                                </div> 
                                <div class="flex_layout flex_xy_center">
                                    <span class="payment-description">{{item.description}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="detail-close-btn flex_layout flex_xy_center">
                        <span @click.self="clickCloseDialog"></span>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="h_loading">
            <transition name="fadeloading">
                <div class="pop-body-loading">
                    <div class="fl spinner1">
                        <div class="double-bounce1"></div>
                        <div class="double-bounce2"></div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import {
    toast,
    debug,
    ua,
    getDeepVal,
    fenToYuan,
} from '@kkmh/utils'
import {
    getPayParam,
} from "../../../assets/utils";
import {
    getBaseParam,
    checkParamPassed,
    jumpNativeDirectPage,
    jumpBrowserDirectPage,
    jumpMiniDirectPage,
    getDetailData,
    getViewData,
} from "../js/common";
export default {
    name: 'Cashdesk',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param:{
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {
            h_visible : false,
            h_transition : false,
            h_loading : false,
            
            nickname : '',
            good_title : '',
            good_price : 0,
            paytypes : {},
            request_id : '',
            
            j_req : {},
        }
    },
    watch:{
        visible:{
            handler(val){
                if(val) {
                    setTimeout(() => {
                        this.init();
                        this.notifyResetVisibleFalse();
                    },0);
                }
            },
            deep:true
        },
        param:{
            handler(val){
                this.j_req = JSON.parse(JSON.stringify(val));
            },
            deep:true
        },
    },
    methods: {
        init(){
            (async () => {
                this.j_req = await getBaseParam(this.j_req);
                let {code, data={}, message} = await checkParamPassed(this.j_req);
                if (code !== 200) {
                    this.notifyErrorMessage(code, message);
                    return null;
                }
                this.nickname = getDeepVal(data,'user.nickname','');
                if (ua.kkmh) {
                    this.inNative();
                } else if(ua.miniprogram) {
                    this.inMiniprogram();
                } else {
                    this.inBrowser();
                }
            })();
        },
        inBrowser(){
            (async () => {
                this.h_loading  = true;
                let {code, data={}, message} = await getViewData(this.j_req);
                if (code !== 200) {
                    this.notifyErrorMessage(code, message);
                    return null;
                }
                this.good_title = data.good_title;
                this.good_price = data.good_price;
                this.paytypes   = data.paytypes;
                this.request_id = data.request_id;
                this.openDialog();
            })();
        },
        inMiniprogram(){
            this.notifyDialogClose();
            jumpMiniDirectPage(getPayParam(this.j_req));
        },
        inNative(){
            if (ua.appversion < 515000) { 
                toast('大佬更新下版本吧，版本太旧了～');
                return null;
            }
            this.notifyDialogOpen();
            jumpNativeDirectPage(this.j_req, (res, nativecallback_name) => {
                let {code=0, data={}, message=''} = res;
                if (code !== 200) {
                    toast('掉起收银台异常');
                }
                if (data.pay_status == 5) {
                    toast('没有找到对应商品');
                }
                this.notifyPayMessage({code, data, message});
            })
            this.notifyDialogClose();
        },
        clickPay(pay_type){
            this.notifyDialogClose();
            jumpBrowserDirectPage(getPayParam(this.j_req), pay_type, this.request_id);
        },
        clickCloseDialog(){
            this.closeDialog();
        },
        // browser开启
        openDialog(){
            this.h_loading = false;
            this.h_visible = true;
            this.$nextTick(() => {
                this.h_transition = this.h_visible;
            })
            this.notifyDialogOpen();
        },
        // browser关闭
        closeDialog(){
            if (!this.h_visible) {
                return null;
            }
            this.h_transition = false;
            setTimeout(() => {
                this.h_visible = false;
            },300)
            this.notifyDialogClose();
        },
        // 收银台组件-通知 : 打开
        notifyDialogOpen(){
            debug(`【收银台 - 打开】`);
            this.$emit('dialogOpen');
        },
        // 收银台组件-通知 : 关闭
        notifyDialogClose(){
            debug(`【收银台 - 关闭】`);
            this.$emit('dialogClose');
        },
        // 收银台组件-通知 : 支付信息
        notifyPayMessage(res){
            debug(`【收银台 - 支付信息】`,res);
            this.$emit('payMessage', res);
        },
        // 收银台组件-通知 : 出错
        notifyErrorMessage(code, message, data={}){
            this.h_loading = false;
            let info = ua.prod ? `${message}` : `[${code}]-${message}`
            toast(`支付遇到问题~ ${info}`);
            debug(`【收银台 - 出错】${info}`);
            this.$emit("errorMessage", {code, data, message});
        },
        // 收银台组件-通知 : 更新visible重制才能重新点击打开
        notifyResetVisibleFalse(){
            // debug(`【收银台 - 重制visible】`);
            this.$emit('update:visible', false);
        },
        // 收银台组件-通知 : 商品详情信息 vip/kkb （父组件通过ref可以调用）
        getGoodData(){
            setTimeout(() => {
                (async () => {
                    let opt = await getBaseParam(this.j_req);
                    let res = await getDetailData(opt);
                    debug(`【收银台 - 商品详情信息】`,res);
                    this.$emit('goodData',res);
                })()
            },0);
        },

    },
    filters:{
        formatFenToYuan(v){
            return fenToYuan(v,2);
        }
    }
}

</script>
<style lang="scss" scoped>
@import "../../../assets/styles/flex.css";

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
    -webkit-animation: bounce-in 0.3s ease forwards;
    animation: bounce-in 0.3s ease forwards;
}
.fade-leave-active {
    -webkit-animation: bounce-in 0.3s ease forwards reverse;
    animation: bounce-in 0.3s ease forwards reverse;
}
@-webkit-keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
.containerr, .containerr * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-size:18px;
}
.containerr{
    position:fixed;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.5);
    z-index:9999;
}
.payment-container {
    width: 270px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .payment-title {
        width: 100%;
        height: 50px;
        font-size: 14px;
        color: #000;
    }
    .payment-detail {
        width: 100%;
        background-color: #F7F9FA;
        overflow: hidden;
        .detail-title {
            font-size: 14px;
            color: #999;
            line-height: 14px;
            margin-top: 22px;
            text-align: center;
            padding: 0 10px;
        }
        .detail-price {
            font-size: 32px;
            color: #666;
            margin-top: 8px;
            text-align: center;
            .money-icon {
                margin-right: 4px;
            }
        }
    }
    .detail-list-container {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        overflow: hidden;
        .detail-list {
            width: 100%;
            height: 46px;
            border-bottom: 1px solid #eee;
            list-style: none;
            .payment-icon {
                width: 20px;
                height: 20px;
                display: inline-block;
                margin-left: 18px;
            }
            .payment-icon-activity {
                height: 20px;
                width: auto;
                display: inline-block;
                margin-left: 2px;
                vertical-align: middle;
            }
            .payment-description {
                font-size: 12px;
                color:#999;
                margin-right: 10px;
            }
            .payment-descriptionweixin {
                font-size: 12px;
                color: #999;
                transform: scale(.6) translateX(-25%);
                display: block;
            }
            .payment-name {
                font-size: 14px;
                line-height: 14px;
                color: #333;
                margin-left: 8px;
            }
        }
    }
}
.detail-close-btn {
    padding-top:20px;
    span{
        width: 27px;
        height: 27px;
        display: inline-block;
        background-image: url(https://static3w.kuaikanmanhua.com/assets/img/pay/close-icon_0690bfa.png);
        background-size: 100% 100%; 
    }
}

@media (max-width:320px) { 
    .payment-container{
        width: 230px;
    }
}

.pop-body-loading{
    position: fixed;left: 0;top: 0;width: 100%;height: 100%;background: rgba(0,0,0,.1);z-index: 100;
}
.fadeloading-enter-active, .fadeloading-leave-active {
  transition: opacity .5s;
}
.fadeloading-enter, .fadeloading-leave-to /* .fadeloading-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.spinner1 {
    width: 40px;
    height: 40px;
    position: relative;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}
.double-bounce1, .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-animation: bounce 2.0s infinite ease-in-out;
    animation: bounce 2.0s infinite ease-in-out;
}
.double-bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}
@-webkit-keyframes bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes bounce {
  0%, 100% { 
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% { 
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>








// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/cashdesk/src/cashdesk.vue